<template>
    <div class="fileList documentation__fileList">
      <div v-if="documents.length && getCategoryBySlug()">
            <h3 v-if="type === 'documents'" class="fileList__title">Stáhněte si potřebné dokumenty</h3>
            <download-document-list :documents="getCategoryBySlug()" :type="type" v-if="type === 'documents'"/>
            <cad-construction-list :documents="documents" :type="type" v-if="type==='cad'"/>
        </div>
<!--        <div v-if="!processing && documents.length === 0 && getLastSlug() && !hasChildren()">-->
<!--            Je nám líto, tato kategorie neobsahuje žádné odkazy-->
<!--        </div>-->
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import filter from 'lodash/filter';
    import isUndefined from 'lodash/isUndefined';
    import last from 'lodash/last';
    import first from 'lodash/first';
    import {SLUG_SEPARATOR} from './const';
    import DownloadDocumentList from "./DocumentList";
    import CadConstructionList from "../cad/ConstructionList";

    export default {
        name: 'DownloadMainList',
        components: {CadConstructionList, DownloadDocumentList},
        computed: {
            ...mapGetters('download', ['documents', 'categories', 'type', '']),
            ...mapState('download', {
                processing: state => state.documents.processing
            })
        },
        watch: {
            '$route': function () {
                this.loadDocuments();
            },
        },
        mounted() {
            this.loadDocuments();
        },
      methods: {
        ...mapActions('download', ['fetchDocuments']),
        loadDocuments() {
          const categoryId = this.getLastSlug();
          if (categoryId) {
            this.fetchDocuments(categoryId);
          }
        },
        getLastSlug() {
          const {slug} = this.$route.params;
          if (isUndefined(slug)) {
            return null;
          }
          return last(slug.split(SLUG_SEPARATOR));
        },
        getCategoryBySlug() {
          const slug = this.getLastSlug();

          // Recursive function to find the category by slug
          const findCategoryBySlug = (categories, slug) => {
            for (const category of categories) {
              if (category.id === slug) {
                return category;
              }
              if (category.children && category.children.length > 0) {
                const result = findCategoryBySlug(category.children, slug);
                if (result) {
                  return result;
                }
              }
            }
            return null;
          };

          if (slug) {
            const category = findCategoryBySlug(this.categories, slug);
            if (category) {
              return category.documents;
            }
          }

          return null;
        },
        hasChildren() {
          const slug = this.getLastSlug();
          return filter(this.categories, category => category.parent_id === slug).length > 0;
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/download/MainList.vue